import { IconButton, Tooltip } from "@mui/material";
import { MapRainforestMarker } from "types/map";
import { RainforestTreeIcon } from "components/icons";

type Props = {
  marker: MapRainforestMarker;
  onMarkerSelect: (marker: MapRainforestMarker | null) => void;
  isSelected: boolean;
  color?: string;
  size: "small" | "medium" | "large";
};

const MapMarkerRainforestButton = ({
  marker,
  onMarkerSelect,
  isSelected,
  color,
  size,
}: Props) => {
  const handleClick = () => {
    onMarkerSelect(isSelected ? null : marker);
  };

  const activeColor = color || "success.main";

  const getIconSize = () => {
    switch (size) {
      case "small":
        return "2rem";
      case "medium":
        return "3rem";
      case "large":
        return "4rem";
      default:
        return "3rem";
    }
  };

  return (
    <>
      <Tooltip title={`Click to view ${marker.name}`} arrow placement="bottom">
        <IconButton
          onClick={handleClick}
          size={size}
          sx={{
            backgroundColor: isSelected ? activeColor : "background.paper",
            color: isSelected ? "background.paper" : activeColor,
            boxShadow: 2,
            p: 0.125,
            "&:hover": {
              backgroundColor: isSelected ? activeColor : "background.paper",
              opacity: 0.9,
            },
          }}
        >
          <RainforestTreeIcon sx={{ fontSize: getIconSize() }} color="inherit" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default MapMarkerRainforestButton;
